/*!
 * Copyright (c) 2015-2017 Cisco Systems, Inc. See LICENSE file.
 */

import AmpState from 'ampersand-state';
import util from 'util';

/**
 * SparkInternalCore is an extra layer of nesting to make it blatantly clear that
 * private plugins are, in fact, private.
 * @class
 */
const SparkInternalCore = AmpState.extend({
  derived: {
    ready: {
      deps: [],
      fn() {
        return Object.keys(this._children).reduce((ready, name) => ready && this[name] && this[name].ready !== false, true);
      }
    }
  },

  /**
   * @instance
   * @memberof SparkPlugin
   * @param {number} depth
   * @private
   * @returns {Object}
   */
  inspect(depth) {
    return util.inspect(this.serialize({
      props: true,
      session: true,
      derived: true
    }), {depth});
  }
});

export default SparkInternalCore;
